/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tasks.vue?vue&type=template&id=6777217e"
import script from "./tasks.vue?vue&type=script&lang=js"
export * from "./tasks.vue?vue&type=script&lang=js"
import style0 from "./tasks.vue?vue&type=style&index=0&id=6777217e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports